export default __webpack_public_path__ + "static/media/photos.8f9c1323.jpg";